// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.draft-bulk-header {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px 20px;
}
.draft-bulk-header > nav,
.draft-bulk-header > .invoice-tabs,
.draft-bulk-header > .rcti-status-tabs {
  min-width: 0;
  flex: 1 1 320px;
  width: auto;
}
.draft-bulk-actions {
  margin-left: auto;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 12px;
  font: inherit;
  font-size: 13px;
  color: var(--text-secondary);
}
input.draft-selection-checkbox {
  width: 16px;
  height: 16px;
  flex: 0 0 16px;
  margin: 0 8px 0 0;
  vertical-align: middle;
  accent-color: var(--interactive-default);
  cursor: pointer;
}
.quotation-table-card input.draft-selection-checkbox[type="checkbox"] {
  margin-inline-end: var(--space-2, 8px);
}
.draft-selection-checkbox:focus-visible,
.draft-bulk-delete:focus-visible { outline: 2px solid var(--interactive-default); outline-offset: 3px; }
.draft-bulk-actions .draft-bulk-delete {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 40px;
  padding: 6px 8px;
  border: 0;
  background: transparent;
  color: var(--danger-text);
  font: inherit;
  font-weight: 500;
  cursor: pointer;
}
.draft-bulk-delete:disabled, .draft-selection-checkbox:disabled { opacity: .55; cursor: not-allowed; }
.draft-number-cell { display: inline-flex; align-items: center; min-width: 0; }
.draft-number-link { color: inherit; font: inherit; background: transparent; border: 0; padding: 0; text-align: left; cursor: pointer; overflow-wrap: anywhere; }
.draft-number-cell > div { min-width: 0; }
@media (max-width: 767px) {
  .draft-bulk-actions { width: 100%; padding-bottom: 8px; }
}
`, "",{"version":3,"sources":["webpack://./src/components/draftBulkActions.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;AACA;;;EAGE,YAAY;EACZ,eAAe;EACf,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,SAAS;EACT,aAAa;EACb,eAAe;EACf,4BAA4B;AAC9B;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,sBAAsB;EACtB,wCAAwC;EACxC,eAAe;AACjB;AACA;EACE,sCAAsC;AACxC;AACA;mCACmC,6CAA6C,EAAE,mBAAmB,EAAE;AACvG;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,uBAAuB;EACvB,yBAAyB;EACzB,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;AACA,kEAAkE,YAAY,EAAE,mBAAmB,EAAE;AACrG,qBAAqB,oBAAoB,EAAE,mBAAmB,EAAE,YAAY,EAAE;AAC9E,qBAAqB,cAAc,EAAE,aAAa,EAAE,uBAAuB,EAAE,SAAS,EAAE,UAAU,EAAE,gBAAgB,EAAE,eAAe,EAAE,uBAAuB,EAAE;AAChK,2BAA2B,YAAY,EAAE;AACzC;EACE,sBAAsB,WAAW,EAAE,mBAAmB,EAAE;AAC1D","sourcesContent":[".draft-bulk-header {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 12px 20px;\n}\n.draft-bulk-header > nav,\n.draft-bulk-header > .invoice-tabs,\n.draft-bulk-header > .rcti-status-tabs {\n  min-width: 0;\n  flex: 1 1 320px;\n  width: auto;\n}\n.draft-bulk-actions {\n  margin-left: auto;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n  gap: 12px;\n  font: inherit;\n  font-size: 13px;\n  color: var(--text-secondary);\n}\ninput.draft-selection-checkbox {\n  width: 16px;\n  height: 16px;\n  flex: 0 0 16px;\n  margin: 0 8px 0 0;\n  vertical-align: middle;\n  accent-color: var(--interactive-default);\n  cursor: pointer;\n}\n.quotation-table-card input.draft-selection-checkbox[type=\"checkbox\"] {\n  margin-inline-end: var(--space-2, 8px);\n}\n.draft-selection-checkbox:focus-visible,\n.draft-bulk-delete:focus-visible { outline: 2px solid var(--interactive-default); outline-offset: 3px; }\n.draft-bulk-actions .draft-bulk-delete {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  min-height: 40px;\n  padding: 6px 8px;\n  border: 0;\n  background: transparent;\n  color: var(--danger-text);\n  font: inherit;\n  font-weight: 500;\n  cursor: pointer;\n}\n.draft-bulk-delete:disabled, .draft-selection-checkbox:disabled { opacity: .55; cursor: not-allowed; }\n.draft-number-cell { display: inline-flex; align-items: center; min-width: 0; }\n.draft-number-link { color: inherit; font: inherit; background: transparent; border: 0; padding: 0; text-align: left; cursor: pointer; overflow-wrap: anywhere; }\n.draft-number-cell > div { min-width: 0; }\n@media (max-width: 767px) {\n  .draft-bulk-actions { width: 100%; padding-bottom: 8px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
